module.exports = __webpack_public_path__ + "media/bootstrap-icons/house-635cf68f.svg";